import React, { useState, useEffect, Fragment } from "react";
import { Link, withRouter, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Drawer,
  DrawerContent,
  DrawerItem,
} from "@progress/kendo-react-layout";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  newProfileIcon,
  newHelpIcon,
  newConfigurationIcon,
  notificationIcon,
  urgentNotificationIcon,
  notificationSmallIcon,
} from "../../../assets/logos/icons";
import {
  DialogSystemGLPure,
  DialogTimerSignOff,
  HelpSectionSliderPure,
  NotificationSliderPure,
} from "../../pures";
import { useMediaQuery } from "@material-ui/core";
import "./app.css";
import { Avatar } from "@progress/kendo-react-layout";
import { Auth0Service, CacheStorageService, ClientContractService, LocalStorageService } from "../../../services";
import ChatBot from "../chatbot/ChatBot";

/* === Custom component for each Item in Drawer === */
const CustomItem = (props) => {
  const { visible, ...others } = props;

  const drawerImageItemMenuStyles = {
    height: "25px",
    width: "100%",
    objectFit: "contain",
  };

  const smallmatches = useMediaQuery("(max-width:800px)");

  const drawerTextItemMenuStyles = {
    margin: "0px",
    color: "#2C353C",
    fontSize: "11px",
    textAlign: "center",
    overflow: "hidden",
    fontFamily: "Quicksand",
    fontWeight: "700",
    lineHeight: "1.3em",
  };
  const draweItemsStyle = {
    alignItems: "center",
    margin: "5px",
  };
  if (smallmatches) {
    drawerTextItemMenuStyles.display = "none";
  }
  const drawerTextItemSubMenuStyles = {
    marginLeft: "15px",
    marginRight: "13px",
    fontWeight: 500,
    fontSize: "15px",
    color: "#4D4D4D",
  };

  let { contractExist, contractsStatus, userHadContracts } = props.contract;
  let routeCanBeAccess;

  // If user has an active and aprove contract (common login)
  if (
    contractExist &&
    contractsStatus ===
    Number(process.env.REACT_APP_USER_CONTRACT_STATUS_APROVED)
  ) {
    routeCanBeAccess = true;

    // If user does not has a contract or is disble but had a contract aprovated proviously
  } else if (
    !contractExist &&
    userHadContracts &&
    contractsStatus ===
    Number(process.env.REACT_APP_USER_CONTRACT_STATUS_APROVED)
  ) {
    routeCanBeAccess = props.route === "/sign-request" ? false : true;

    // If the user contract exist and hab contrasct prevously but is pending to aprove
  } else if (
    contractExist &&
    userHadContracts &&
    contractsStatus ===
    Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
  ) {
    routeCanBeAccess =
      props.route === "/sign-request" || props.route === "/configuration"
        ? false
        : true;

    // If user has a contract expired and had a contract proviously but are expired or rejected
  } else if (
    contractExist &&
    userHadContracts &&
    (contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_EXPIRED) ||
      props.contract.contractsStatus ===
      Number(process.env.REACT_APP_USER_CONTRACT_STATUS_REJECTED))
  ) {
    routeCanBeAccess = props.route === "/sign-request" ? false : true;

    // If the user does not has a contract but is a user Invited
  } else if (
    !contractExist &&
    props.userType.id === Number(process.env.REACT_APP_USER_TYPE_INVITADO)
  ) {
    routeCanBeAccess =
      props.route === "/sign-request" || props.route === "/configuration"
        ? false
        : true;

    // If the user does not has a contract but is a user Collaborator
  } else if (
    !contractExist &&
    props.userType.id === Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
  ) {
    routeCanBeAccess = props.route === "/configuration" ? false : true;
  }

  return (
    <DrawerItem {...others}>
      <Tooltip
        openDelay={600}
        position="right"
        anchorElement="target"
        tooltipClassName="tooltipGeneralStyle"
      >
        {props.parentId === 1 ? (
          <div className="drawer-item-elem">
            <div
              style={draweItemsStyle}
              className={!routeCanBeAccess ? "icon-white" : ""}
            >
              <div style={{ textAlign: "center" }}>
                <img
                  alt="Icono del menu"
                  src={props.icon}
                  style={drawerImageItemMenuStyles}
                  title={props.tooltipText}
                />
              </div>
              <p style={drawerTextItemMenuStyles} title={props.tooltipText}>
                {props.text}
              </p>
            </div>
          </div>
        ) : (
          <div className="drawer-item-elem">
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={!routeCanBeAccess ? "icon-white" : ""}
            >
              <span className="icon-visibility" title={props.tooltipText}>
                {props.text
                  .match(/\b\w/g)
                  .toString()
                  .toUpperCase()
                  .replace(/,/g, "")}
              </span>
              <span
                className={"k-item-text"}
                style={drawerTextItemSubMenuStyles}
                title={props.tooltipText}
              >
                {props.text}
              </span>
            </div>
          </div>
        )}
      </Tooltip>
    </DrawerItem>
  )
};

/* Component to render configuration icon in header */
const ConfigurationIconTop = ({ contract, userType, t }) => {
  let { contractExist, contractsStatus, userHadContracts } = contract;

  if (
    contractExist &&
    userHadContracts &&
    contractsStatus ===
    Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
  ) {
    return null;
  } else if (
    !contractExist &&
    userType.id === Number(process.env.REACT_APP_USER_TYPE_INVITADO)
  ) {
    return null;
  } else if (
    !contractExist &&
    userType.id === Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
  ) {
    return null;
  }
  return (
    <Tooltip
      openDelay={600}
      position="bottom"
      anchorElement="target"
      tooltipClassName="tooltipGeneralStyle tooltipTouchHidden"
    >
      <div>
        <Link style={{ display: "flex" }} to={`/configuration`}>
          <img
            alt="config-icon"
            src={newConfigurationIcon}
            className="avatar-profile-icon header-icon"
            title={t("appView.tooltip.config")}
          />
        </Link>
      </div>
    </Tooltip>
  );
};

/* === Component Drawer and container of App === */
const AppView = (props) => {
  const [showSideMenuExpanded, setShowSideMenuExpanded] = useState(
    props.expanded
  );

  const url = process.env.REACT_APP_MIFIRMA_API;
  const clientContractService = new ClientContractService(url);
  const localStorageService = new LocalStorageService()
  const cacheStorageService = new CacheStorageService()
  const auth0Service = new Auth0Service()

  let selected = props.setSelectedItem(props.location.pathname);
  const [forceMobile, setForceMobile] = useState(false);
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const displayDrawer = useMediaQuery("(min-width:500px)");

  props.checkForAuthorization(props.history);
  props.checkForSignRequest(props.history);

  const handleMobileSyncfusionView = async () => {
    if (localStorage.getItem('clientContractId') && localStorage.getItem("token")) {
      const token = localStorageService.getLocalStorageItem("token").idToken;
      await clientContractService.setIsOpenClientContract(Number(localStorage.getItem('clientContractId')), false, token)
      localStorage.removeItem('clientContractId')
    }
  }

  const initTimeout = () => {
    return setTimeout(async () => {
      let logo = localStorageService.getLocalStorageItem("clientLogo");
      localStorageService.clearLocalStorage();
      cacheStorageService.clearCache();
      localStorageService.setLocalStorageItem(
        "clientLogo",
        logo ? logo : ""
      );
      await auth0Service.logout()
    }, +process.env.REACT_APP_LIMIT_TIME)
  }

  useEffect(() => {
    setShowSideMenuExpanded(props.expanded);
    if (props.matchMobileResolution) {
      setShowSideMenuExpanded(!props.expanded);
    }
  }, [props.expanded, props.matchMobileResolution]);

  // UseEffect to verify if is syncfusion edit-doc route
  useEffect(() => {
    if (props.history && props.history.location && props.history.location.pathname.includes("edit-docx")) {
      if (document.getElementById("hamburger-icon")) document.getElementById("hamburger-icon").style = "display:block;";

      if (props.expanded) {
        setShowSideMenuExpanded(!props.expanded);
        setForceMobile(true);
        props.toggleExpandedSideMenu();
        props.toggleExpandedSideMenu();
      }
    } else if (localStorage.getItem('currentUrl') && localStorage.getItem('currentUrl').includes('edit-docx') && window.innerWidth > 500) {
      localStorage.setItem('currentUrl', props.history.location.pathname)

      handleMobileSyncfusionView()

      if (document.getElementById("hamburger-icon")) document.getElementById("hamburger-icon").style = "";

      if (!props.expanded) {
        setShowSideMenuExpanded(props.expanded);
        setForceMobile(false);
        props.toggleExpandedSideMenu();
        props.toggleExpandedSideMenu();
      }
    }
  }, [props.history.location.pathname]);

  useEffect(() => {
    let timeout = initTimeout()
    window.addEventListener("click", () => {
      clearTimeout(timeout)
      timeout = initTimeout()
    })
    return () => {
      clearTimeout(timeout)
      timeout = initTimeout()
    }
  }, [])

  return (
    <Fragment>
      <div className="app-view">
        {/* Help Section Icon */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "10px",
          }}
        >
          <div className="help-profile-icons">
            <div
              className="notification-section show"
              onClick={props.toggleNotification}
            >
              <Tooltip
                openDelay={600}
                position="bottom"
                anchorElement="target"
                tooltipClassName="tooltipGeneralStyle tooltipTouchHidden"
              >
                <div className="icon-button">
                  {
                    props.highPriority ? (
                      <img
                        alt="notification-icon"
                        className="header-icon"
                        src={urgentNotificationIcon}
                        title={props.t("appView.tooltip.notifications")}
                      />
                    ) : (
                      <img
                        alt="notification-icon"
                        className="header-icon"
                        src={
                          props.notificationQuantity > 0
                            ? notificationSmallIcon
                            : notificationIcon
                        }
                        title={props.t("appView.tooltip.notifications")}
                      />
                    )
                    // <span class="material-symbols-outlined">
                    //   notifications
                    // </span>
                  }
                  {props.notificationQuantity > 0 ? (
                    props.notificationQuantity > 9 ? (
                      <span class="icon-button-badge-full">+9</span>
                    ) : (
                      <span class="icon-button-badge">
                        {props.notificationQuantity}
                      </span>
                    )
                  ) : null}
                </div>
              </Tooltip>
            </div>
            <div
              className="help-section show"
              onClick={props.toggleHelpSection}
            >
              <Tooltip
                openDelay={600}
                position="bottom"
                anchorElement="target"
                tooltipClassName="tooltipGeneralStyle tooltipTouchHidden"
              >
                <img
                  alt="help-icon"
                  className="header-icon"
                  src={newHelpIcon}
                  title={props.t("appView.tooltip.help")}
                />
              </Tooltip>
            </div>

            <Tooltip
              openDelay={600}
              position="bottom"
              anchorElement="target"
              tooltipClassName="tooltipGeneralStyle tooltipTouchHidden"
            >
              <div>
                {props.userPathImage ? (
                  <Avatar
                    shape="circle"
                    type="image"
                    className="avatar-profile-user-img"
                  >
                    <Link style={{ display: "flex" }} to={`/profile`}>
                      <img
                        src={props.userPathImage}
                        alt="user-img"
                        className="k-avatar-image"
                        style={{ borderRadius: "50%" }}
                        title={props.userName}
                      />
                    </Link>
                  </Avatar>
                ) : (
                  <Link
                    style={{ display: "flex", paddingLeft: "10px" }}
                    to={`/profile`}
                    title={props.userName}
                  >
                    <img
                      src={newProfileIcon}
                      className="header-icon"
                      alt="profile-icon"
                      height="30px"
                    />
                  </Link>
                )}
              </div>
            </Tooltip>
            <ConfigurationIconTop
              contract={props.contract}
              userType={props.userType}
              t={props.t}
            />
          </div>
          {/* Help Section Slider Panel */}
          <HelpSectionSliderPure
            helpSection={props.helpSection}
            helpSectionFirstsFaqs={props.helpSectionFirstsFaqs}
            helpSectionFirstVideo={props.helpSectionFirstVideo}
            helpSectionSelect={props.helpSectionSelect}
            showHelpSection={props.showHelpSection}
            showHelpSectionSelect={props.showHelpSectionSelect}
            initializeHelpSection={props.initializeHelpSection}
            toggleHelpSection={props.toggleHelpSection}
            toggleHelpSectionQuestionAnswer={
              props.toggleHelpSectionQuestionAnswer
            }
            onSelectHelpSection={props.onSelectHelpSection}
            onClickReturnHelpSection={props.onClickReturnHelpSection}
            onClickNextHelpSection={props.onClickNextHelpSection}
            lastPostImg={props.lastPostImg}
            lastPostDate={props.lastPostDate}
            lastPostTitle={props.lastPostTitle}
            lastPostDescription={props.lastPostDescription}
            lastPostSeeMore={props.lastPostSeeMore}
          />
          {/* Notification Section Slider Panel*/}
          <NotificationSliderPure
            initializeNotification={props.initializeNotification}
            showNotification={props.showNotification}
            toggleNotification={props.toggleNotification}
            playSound={props.playSound}
            toggleSoundActive={props.toggleSoundActive}
            soundActive={props.soundActive}
            onUpdateNotification={props.onUpdateNotification}
            onUpdateSocket={props.onUpdateSocket}
            socket={props.notification}
          ></NotificationSliderPure>
        </div>

        <Drawer
          expanded={showSideMenuExpanded} // || displayDrawer
          className={(props.expanded ? "" : "isDrawerOpen", "app-resize")}
          position="start"
          mode={props.matchMobileResolution || forceMobile ? "overlay" : "push"}
          items={props.items
            .map((item) => ({
              ...item,
              selected: item.text === selected,
              contract: props.contract.data,
              userType: props.userType,
            }))
            .filter(
              (item) =>
                item.route !== "/profile" && item.route !== "/configuration"
            )}
          item={CustomItem}
          animation={{ duration: 400 }}
          onSelect={(event) => {
            if (event.itemTarget.props.route === "/close-session") {
              props.handleButtonLogOut();
            } else if (
              event.itemTarget.props.route === "/" &&
              props.contract.data.contractsStatus ===
              Number(process.env.REACT_APP_USER_CONTRACT_STATUS_PENDING)
            ) {
              props.history.push("/waiting-authorization");
            } else {
              props.onSelect(event, props.history);
            }
          }}
          onOverlayClick={props.toggleExpandedSideMenu}
        >
          <DrawerContent>
            <div className="div-con-fondo">{props.children}</div>
          </DrawerContent>
        </Drawer>
        {/* <PromotionalFooterPure 
          {...props} 
        /> */}
        {/* Alerts of Notification Loadign, Completed and Error */}
        <DialogSystemGLPure
          {...props}
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
          toggleWarningRequesting={props.toggleWarningRequesting}
          message={props.message}
        />
        {/* Timer to sign off the sesion in application */}
        <DialogTimerSignOff
          {...props}
          toggleDialogTimerSignOff={props.toggleDialogTimerSignOff}
          onSignOffByTimerEnd={props.onSignOffByTimerEnd}
          onSignOffByUser={props.onSignOffByUser}
          onRefreshUserToken={props.onRefreshUserToken}
        />

        {process.env.REACT_APP_FEATURE_FLAG === "true" && <ChatBot />}
      </div>
    </Fragment>
  );
};

export default withRouter(AppView);
